import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceInviteMembersNotificationState = createStateReducer(initialState, {
  [events.inviteMembersFailed]: (state, error) => ({
    ...state,
    queue: updateNotification(
      {
        key: "inviteMembers",
        flags: [
          error.failedInvitations.length > 1
            ? "failurePlural"
            : "failureSingular",
        ],
        args: {
          failure: "true",
          failedInvitationNbr: error.failedInvitations.length.toString(),
        },
      },
      state.queue,
    ),
  }),
});

export { reduceInviteMembersNotificationState };
